/**
 * 城市
 */
import { get } from '../utils/http';
import City from '../models/City';
import Region from '../models/Region';


// doc: https://doc.oschina.net/xingchengzushou?t=244228
export function getListByRegionId(region_id, page) {
  let url = '/m/v2/?m=api/poi/destination/city_list';

  return get(url, {
    data: {region_id, page}
  })
    .then(function (data) {
      data.list = data.list.map(function (city) {
        return City.parseInput2(city);
      });
      return data;
    });
}



export function search(search_word, page) {
  let url = '/m/v2/?m=api/poi/destination/search';

  return get(url, {
    data: {search_word, page}
  })
    .then(function (data) {
      let result = [];
      data.list.forEach(function (item) {
        let obj;
        if (item.type === 'region') {
          obj = Region.parseInput2(item);
          result.push(obj);
        } else if (item.type === 'city') {
          obj = City.parseInput3(item);
          result.push(obj);
        }
      });

      return { list: result, pager: data.pager};
    });
}




// WEBPACK FOOTER //
// ./src/services/city.js